//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {

  data: () => ({
    info: '',
    dialogVisible: false,
    currentUserType: '',
    user: '',
    msgNum: '',
    badgeNum: 0,
    isdot: ''
  }),
  methods: {

    //获取个人信息
    getInfo() {
      this.$get('/sys/user/info', '', function (res) {
        if (res.code == 200) {
          this.info = res.data;
          if (getLocal('user')) {
            var user = getLocal('user')
            user.nickName = res.data.nickName;
            user.identifier = res.data.contactNumber;
            user.currentUserType = res.data.currentUserType
            setLocal('user', user)
            setSession('user', user)
            this.user = getSession('user')
          }
        } else {
          this.info = ''
        }
      })
    },

    // 获取未读消息数量
    messageShow() {
      this.$get('/sys/user/message/unreadList?isRead=1', function (res) {
        if (res.code == 200) {
          if (JSON.stringify(res.data) == '{}') {
            this.badgeNum = 0;
            this.isdot = true;
          } else {
            var msgNum = res.data;
            this.badgeNum = 0;
            for (let i of Object.values(msgNum)) {
              this.badgeNum += i;
            }
            this.isdot = this.badgeNum > 0 ? false : true;
          }
        }
      })
    },

    //草稿中的项目
    draft() {
      this.$router.push({
        path: '/outsourcer/draftPro'
      })
    },

    // 发布中的项目
    release() {
      this.$router.push({
        path: '/outsourcer/releasePro'
      })
    },
    // 投标中的项目
    bidPro() {
      this.$router.push({
        path: '/facilitator/bidPro'
      })
    },
    // 进程中项目
    progress() {
      this.$router.push({
        path: '/common/underwayPro'
      })
    },
    // 完成中项目
    complete() {
      this.$router.push({
        path: '/common/completedPro'
      })
    },
    // 用户未登录
    loginBtn() {
      var source = this.$route.query.source ? this.$route.query.source : '7'
      this.$router.push({
        path: '/login?logins=1&state=' + source
      })
    },

    //查看个人信息(修改之前)
    setInfo() {
      if (!getSession('user')) {
        this.$confirm('当前还未登录,登录后才可操作', '提示', {
          confirmButtonText: '去登录',
          type: 'info'
        }).then(() => {
          this.$router.push({
            path: '/login?logins=1'
          })
        })
        return
      }
      this.$router.push({
        path: '/person/personInfo'
      })
    },
    // 安全中心
    safeCenter() {
      if (!getSession('user')) {
        this.$confirm('当前还未登录,登录后才可操作', '提示', {
          confirmButtonText: '去登录',
          type: 'info'
        }).then(() => {
          this.$router.push({
            path: '/login?logins=1'
          })
        })
        return
      }
      this.$router.push({
        path: '/person/safeCenter'
      })
    },
    //认证中心
    authenticCenter() {
      if (!getSession('user')) {
        this.$confirm('当前还未登录,登录后才可操作', '提示', {
          confirmButtonText: '去登录',
          type: 'info'
        }).then(() => {
          this.$router.push({
            path: '/login?logins=1'
          })
        })
        return
      }
      if (this.info.currentUserType == 1) {
        this.$router.push({
          path: '/person/choose?id=' + this.info.id
        })
      } else {
        this.$router.push({
          path: '/person/renzheng'
        })
      }
    },

    // 我的钱包
    myWallet() {
      if (!getSession('user')) {
        this.$confirm('当前还未登录,登录后才可操作', '提示', {
          confirmButtonText: '去登录',
          type: 'info'
        }).then(() => {
          this.$router.push({
            path: '/login?logins=1'
          })
        })
        return
      }
      this.$router.push({
        path: '/person/myWallet'
      })
    },

    // 我的优惠券
    myCoupon() {
      if (!getSession('user')) {
        this.$confirm('当前还未登录,登录后才可操作', '提示', {
          confirmButtonText: '去登录',
          type: 'info'
        }).then(() => {
          this.$router.push({
            path: '/login?logins=1'
          })
        })
        return
      }
      this.$router.push({
        path: '/person/myCoupon'
      })
    },

    // 我的收藏
    myCollect(){
      if (!getSession('user')) {
        this.$confirm('当前还未登录,登录后才可操作', '提示', {
          confirmButtonText: '去登录',
          type: 'info'
        }).then(() => {
          this.$router.push({
            path: '/login?logins=1'
          })
        })
        return
      }
      this.$router.push({
        path: '/person/myCollect'
      })
    },

    // 我的消息
    myMessage() {
      if (!getSession('user')) {
        this.$confirm('当前还未登录,登录后才可操作', '提示', {
          confirmButtonText: '去登录',
          type: 'info'
        }).then(() => {
          this.$router.push({
            path: '/login?logins=1'
          })
        })
        return
      }
      this.$router.push({
        path: '/person/myMessage'
      })
    },

    // 客服中心
    serviceCenter() {
      this.$router.push({
        path: '/person/serviceCenter'
      })
    },

    // 切换身份
    changeIdentifier(type) {
      if (type == 1) {
        this.dialogVisible = true
      } else {
        var tips = ''
        if (type == 2) {
          this.currentUserType = 3
          tips = '当前身份是发包商,确定要切换为服务商吗'
        } else {
          this.currentUserType = 2
          tips = '当前身份是服务商,确定要切换为发包商吗'
        }
        this.$confirm(tips, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.ensureUserType()
        }).catch(() => {
          //进行错误捕获，不然会提示该错误Uncaught (in promise) cancel
        })
      }
    },
    //确定切换
    ensureUserType() {
      if (!this.currentUserType) {
        this.$message.info('请选择身份后在进行切换')
        return
      }
      var userType = this.currentUserType
      this.$put('/sys/user/convert/identity?currentUserType=' + userType + '&id=' + this.info.id, '', function (res) {
        if (res.code == 200) {
          // if( getLocal('user')){
          //     var user = getLocal('user')
          //     user.currentUserType = userType
          //     setLocal('user',user)
          //     setSession('user', user)
          // }
          this.getInfo()
        }
      }, true)
    }

  },
  mounted() {
    this.getInfo()
    this.messageShow()
  }
}
